module.exports = __webpack_public_path__ + "img/ring_g_s_null_null@3x.61517397.png";